<template>

    <div class="mt-3">

        <div v-if="mode == 'Success'">

            <div class="row">
                <div class="col">
                    <h5>
                        Thank you <br />
                        Your message has been sent. <br />
                        If you haven&apos;t heard back from us after 2 business days (Monday through Friday), please call us. <br />
                        <span class="text-portal-soft-red">
                            If you are having medical problems and need help right away, please do not wait for a reply to the message you sent. Please call your provider&apos;s office or call 212-639-2000 as soon as possible.
                        </span>
                    </h5>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <!-- the class selector is for the ios app. Don't remove the id!-->
                    <a class="go-to-login" href="/">Back to log in screen</a>
                </div>
            </div>

        </div>

        <div v-if="mode == 'Entry'">

            <div id="confirmCancelDialog" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmCancel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Cancel Confirmation</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            Are you sure you want to cancel?
                        </div>
                        <div class="modal-footer">
                            <!-- the class selector is for the ios app. Don't remove the id!-->
                            <a href="/" class="go-to-login btn btn-primary pl-3 pr-3">Yes</a>

                            <button type="button" class="btn btn-primary pl-3 pr-3" data-dismiss="modal">No</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <h5 class="mb-0" style="border-bottom: 1px solid #979797; padding-bottom:15px;">Email to MyMSK Help Desk</h5>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    Required Fields <is-required />
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <transition name="fade">
                        <validation-summary-component :error-messages="errorModel"></validation-summary-component>
                    </transition>
                </div>
            </div>

            <div class="form-row">
                <div class="col form-group">
                    <div>
                        <h5><label for="subject">Subject: <is-required /></label></h5>
                        <input id="subject" type="text" v-error-message="{ errorModel: 'errorModel.subject' }" class="form-control form-control-lg fs-18" maxlength="100" v-model="saveModel.subject" placeholder="Subject">
                        <span class="invalid-feedback is-invalid">{{errorModel.subject | firstError}}</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col form-group">
                    <div>
                        <h5><label for="firstName">Your First Name: <is-required /></label></h5>
                        <input id="firstName" type="text" v-error-message="{ errorModel: 'errorModel.firstName' }" class="form-control form-control-lg fs-18" maxlength="100" v-model="saveModel.firstName" placeholder="First Name">
                        <span class="invalid-feedback is-invalid">{{errorModel.firstName | firstError}}</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col form-group">
                    <div>
                        <h5><label for="lastName">Your Last Name: <is-required /></label></h5>
                        <input id="lastName" type="text" v-error-message="{ errorModel: 'errorModel.lastName' }" class="form-control form-control-lg fs-18" maxlength="100" v-model="saveModel.lastName" placeholder="Last Name">
                        <span class="invalid-feedback is-invalid">{{errorModel.lastName | firstError}}</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col form-group">
                    <div>
                        <h5><label for="emailAddress">Your Email Address: <is-required /></label></h5>
                        <input id="emailAddress" type="text" v-error-message="{ errorModel: 'errorModel.emailAddress' }" class="form-control form-control-lg fs-18" maxlength="100" v-model="saveModel.emailAddress" placeholder="email.address@example.com">
                        <span class="invalid-feedback is-invalid">{{errorModel.emailAddress | firstError}}</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col form-group">
                    <div>
                        <h5><label for="confirmEmailAddress">Confirm Email Address: <is-required /></label></h5>
                        <input id="confirmEmailAddress" type="text" v-error-message="{ errorModel: 'errorModel.confirmEmailAddress' }" class="form-control form-control-lg fs-18" maxlength="100" v-model="saveModel.confirmEmailAddress" placeholder="email.address@example.com">
                        <span class="invalid-feedback is-invalid">{{errorModel.confirmEmailAddress | firstError}}</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col form-group">
                    <div>
                        <h5><label for="messageText">Message Text: <is-required /></label></h5>
                        <textarea maxlength="2000"
                                  v-model="saveModel.messageBody"
                                  v-error-message="{ errorModel: 'errorModel.messageBody' }"
                                  rows="7"
                                  class="form-control"
                                  style="background-image: none !important"
                                  placeholder="Message"></textarea>

                        <div class="fs-12">(Approximately 2000 characters - approx. 300 words) </div>
                        <div v-if="saveModel.messageBody" class="fs-12 font-weight-bold">You have entered {{saveModel.messageBody.length}} characters.</div>
                        <span class="invalid-feedback is-invalid">{{errorModel.messageBody | firstError}}</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col text-right">
                    <div class="g-recaptcha d-inline-block"
                         data-callback="imNotARobotEventChanged"
                         data-expired-callback="dataExpiredCallBack"
                         :data-sitekey="captchaSiteKey"></div>
                </div>
            </div>

            <div v-if="reCaptchaHasError" class="form-row">
                <div class="col text-right">
                    <span class="invalid-feedback is-invalid  d-inline-block">re-CAPTCHA is required</span>
                </div>
            </div>

            <div class="row mt-3 d-flex justify-content-end">

                <div class="col-12 col-md-auto">
                    <button type="button" :disabled="isSaving" class="btn btn-link entry-button fs-18 w-100" data-toggle="modal" data-target="#confirmCancelDialog">Cancel</button>
                </div>

                <div class="col-12 col-md-auto">
                    <button type="button" class="btn btn-primary entry-button fs-18 w-100" :disabled="isSaving" @click="sendMessage">
                        <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Send Message
                    </button>
                </div>
            </div>

        </div>

    </div>

</template>

<style>
    .is-required {
        color: red;
    }
</style>

<script>

    import Vue from 'vue';
    import './message.helpdesk.entry.scss';
    import errorMessageDirective from '@SharedVueComponents/Validation/ErrorMessageDirective';
    import validationSummaryComponent from '@SharedVueComponents/Validation/ErrorSummary.vue'
    import { IsModelStateError } from '@SharedServices/validation.service';
    import composeMessageBody from '@PortalEntryPoints/Messages/ComposeMessage/Components/Common/message.body.vue';
    import { MessageToHelpDeskHttpSvc } from '@SharedHttpServices/message.to.helpdesk.httpservice';

    Vue.component('is-required', {
        template: `<span class="is-required">*</span>`,
    });

    //recaptcha isn't responsive at all. so we need to hack this a bit.
    function resizeReCaptcha() {
        var width = $('.g-recaptcha').parent().width();
        let element = $('.g-recaptcha');

        if (width < 302) {
            let scale = width / 302;

            element.css('transform', 'scale(' + scale + ')');
            element.css('-webkit-transform', 'scale(' + scale + ')');
            element.css('transform-origin', '0 0');
            element.css('-webkit-transform-origin', '0 0');
        }
        else {
            element.css('transform', '');
            element.css('-webkit-transform', '');
            element.css('transform-origin', '');
            element.css('-webkit-transform-origin', '');
        }
    };

    $(document).ready(function () {
        $(window).on('resize', () => {
            resizeReCaptcha();
        });
        resizeReCaptcha();
    });

    export default {
        components: {
            'validation-summary-component': validationSummaryComponent,
            'message-body-component': composeMessageBody
        },
        props: {
            captchaSiteKey: { type: String }
        },
        data: function () {
            return {
                mode: 'Entry', //'Success'
                cmsContentBlocks: {},
                errorModel: {},
                isSaving: false,

                saveModel: {
                    subject: null,
                    firstName: null,
                    lastName: null,
                    emailAddress: null,
                    confirmEmailAddress: null,
                    messageBody: null,

                    ReCaptcha: null
                }
            }
        },
        created: function () {

            window.dataExpiredCallBack = () => {
                this.saveModel.ReCaptcha = null;
            };

            window.imNotARobotEventChanged = (x) => {
                Vue.delete(this.errorModel, 'reCaptcha');
                this.saveModel.ReCaptcha = x;
            };
        },
        computed: {

            reCaptchaHasError: function () {
                return this.errorModel['reCaptcha'] && this.errorModel['reCaptcha'].length > 0;
            }
        },
        methods: {

            sendMessage: function () {
                this.isSaving = true;
                this.errorModel = {};

                MessageToHelpDeskHttpSvc.ContactUsMessageToHelpDesk(this.saveModel)
                    .done(response => {

                        this.mode = 'Success';

                    }).fail((xhr, textStatus, obj) => {

                        if (IsModelStateError(xhr)) {
                            this.errorModel = xhr.responseJSON;

                            //reset the recaptcha
                            grecaptcha.reset();

                            window.dataExpiredCallBack();
                        }

                        this.isSaving = false;
                    });
            }
        }
    };
</script>